/**
 * WorkshopUpgradeUpsell — dashboard upsell shown to Connect (free) users.
 *
 * Replaces the generic "Upgrade to Thrive" copy with workshop-specific
 * language: "1 workshop included every month for less than a single workshop".
 */
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Ticket } from 'lucide-react';

export default function WorkshopUpgradeUpsell() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="rounded-3xl overflow-hidden shadow-card bg-gradient-to-br from-cream to-seafoam/40 border border-teal/20"
      data-testid="workshop-upgrade-upsell"
    >
      <div className="p-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-teal/15 flex items-center justify-center">
            <Sparkles className="text-teal-deep" size={20} />
          </div>
          <p className="text-[11px] tracking-[0.2em] uppercase text-teal-deep font-semibold">
            Included with Thrive
          </p>
        </div>

        <h3 className="font-display text-2xl md:text-3xl text-navy leading-tight mb-2">
          One workshop every month, on us.
        </h3>
        <p className="text-text-mid text-sm mb-4">
          Thrive is <strong className="text-navy">$39/month</strong> — less than a single workshop, and includes one every calendar month plus 30% off any additional workshops.
        </p>

        <div className="flex flex-col sm:flex-row gap-2">
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center gap-2 bg-teal hover:bg-teal-deep text-white rounded-full px-5 py-2.5 text-sm font-medium transition-colors"
            data-testid="upsell-see-plans-btn"
          >
            <Ticket size={14} />
            See how it works
            <ArrowRight size={14} />
          </Link>
          <Link
            to="/my-city?tab=workshops"
            className="inline-flex items-center justify-center gap-2 text-teal-deep hover:text-teal text-sm font-medium px-4 py-2.5"
            data-testid="upsell-browse-workshops-btn"
          >
            Browse workshops
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
